import React from 'react';

export const NotFound: React.FC = () => {
  return (
   <div>
     <h1>Page Not Found</h1>
    </div>
  );
};
